import { render, staticRenderFns } from "./special-approval-detail.vue?vue&type=template&id=37180ad7&scoped=true"
import script from "./special-approval-detail.vue?vue&type=script&lang=js"
export * from "./special-approval-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37180ad7",
  null
  
)

export default component.exports